import {useUserOptions,} from '@/assets/js/src/modules/user/_composables/useUserOptions'

export function mapUserOptionByPath (path) {
    let {getUserOption,setUserOption,} = useUserOptions()

    return {
        get () {
            return getUserOption(path)
        },
        set (newValue) {
            setUserOption({option: path, data: newValue,})
        },
    }
}
